import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Layers3, Users, Building2, UserCog, Package, ChevronLeft, HardHat } from "lucide-react";

// Fornecedores e Setores/Disciplinas ficaram fora da v1: não existem as tabelas
// `fornecedores` e `setores` no banco, então as telas eram mock — guardavam em
// memória e perdiam tudo ao recarregar. Os componentes seguem no repositório
// (src/pages/cadastro/Fornecedores.tsx e SetoresDisciplinas.tsx) para a v2;
// aqui saem do menu, e a rota some junto em src/pages/Cadastro.tsx.
const items = [
  { name: "Obras", href: "/cadastro/obras", icon: Building2 },
  { name: "Clientes", href: "/cadastro/clientes", icon: Users },
  { name: "Usuários e Permissões", href: "/cadastro/usuarios", icon: UserCog },
  { name: "Materiais", href: "/cadastro/materiais", icon: Package },
  { name: "Equipamentos", href: "/cadastro/equipamentos", icon: Layers3 },
  { name: "Mão de Obra", href: "/cadastro/mao-de-obra", icon: HardHat },
];

export const CadastroSidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  return (
    <aside className={cn(
      "border-r border-border bg-card p-3 hidden md:flex md:flex-col relative transition-all duration-300",
      collapsed ? "w-16" : "w-64"
    )}>
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="absolute -right-3 top-4 z-10 w-6 h-6 bg-background border border-border rounded-full flex items-center justify-center hover:bg-accent transition-all shadow-lg"
        aria-label={collapsed ? "Expandir menu" : "Recolher menu"}
      >
        <ChevronLeft className={cn("w-4 h-4 text-muted-foreground transition-transform", collapsed && "rotate-180")} />
      </button>
      <nav className="space-y-1">
        {items.map((item) => {
          const active = location.pathname === item.href;
          return (
            <NavLink
              key={item.href}
              to={item.href}
              title={item.name}
              className={cn(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
                active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-accent hover:text-foreground"
              )}
            >
              <item.icon className="h-4 w-4" />
              {!collapsed && <span>{item.name}</span>}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
};
